













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class InviteStateSelf extends Vue {
  @Prop() code!: string;

  get href() {
    return window.location.href;
  }
}
export default InviteStateSelf;
